export default "__VITE_ASSET__Bf7q6SWu__"